import React, { Children } from 'react';
export const PrivacyPolicy = () => {
  return <div className="bg-white" data-id="element-474">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-475">
        <div className="text-center" data-id="element-476">
          <h1 className="text-3xl font-extrabold text-gray-900 sm:text-4xl" data-id="element-477">
            Privacy & Cookie Policy
          </h1>
          <p className="mt-4 text-xl text-gray-500 max-w-3xl mx-auto" data-id="element-478">
            How we collect, use, and protect your personal information.
          </p>
        </div>
        <div className="mt-12 max-w-4xl mx-auto" data-id="element-479">
          <div className="prose prose-rose max-w-none" data-id="element-480">
            <h2 data-id="element-481">Privacy and Cookie Policy - Suretask</h2>
            <p data-id="element-482">
              At Suretask, protecting your privacy is a priority. This policy
              explains what information we collect, how we use it, and how we
              keep it secure, ensuring you have confidence in our handling of
              your personal data.
            </p>
            <h3 data-id="element-483">1. Who We Are</h3>
            <p data-id="element-484">
              Suretask is a UK-based appliance repair and service company
              specializing in essential household appliances.
            </p>
            <h3 data-id="element-485">2. What Information We Collect</h3>
            <p data-id="element-486">
              We may collect the following information from you to provide our
              services and manage your account effectively:
            </p>
            <ul data-id="element-487">
              <li data-id="element-488">
                Your name and contact details: Including your address, email
                (angelene18inandan@gmail.com), and phone number (0800 055 4969).
              </li>
              <li data-id="element-489">
                Payment information: Processed securely through our trusted
                payment providers.
              </li>
              <li data-id="element-490">
                Records of your service plans and repair history: To ensure
                continuity of service and support.
              </li>
            </ul>
            <h3 data-id="element-491">3. How We Use Your Information</h3>
            <p data-id="element-492">We use your data primarily to:</p>
            <ul data-id="element-493">
              <li data-id="element-494">
                Manage and administer your service plans: Including activation,
                renewals, and plan adjustments.
              </li>
              <li data-id="element-495">
                Arrange repairs and provide customer support: Dispatching
                engineers for your appliances, and addressing your queries.
              </li>
              <li data-id="element-496">
                Send important updates and information: Related to your service,
                appointments, and policy changes.
              </li>
              <li data-id="element-497">
                Comply with legal and regulatory obligations: Ensuring we
                operate within the law.
              </li>
            </ul>
            <h3 data-id="element-498">4. Third-Party Providers</h3>
            <p data-id="element-499">
              We work with trusted third parties, such as payment processors and
              website hosting providers, to deliver our services efficiently and
              securely. We want to assure you that we do not sell your personal
              information to any third parties.
            </p>
            <h3 data-id="element-500">5. Cookies</h3>
            <p data-id="element-501">
              Our website uses cookies to enhance your browsing experience and
              improve site performance. Cookies are small data files stored on
              your device that help us understand how you interact with our
              site. You can manage or disable cookies through your browser
              settings at any time, but please note this may affect certain
              website functionalities.
            </p>
            <h3 data-id="element-502">6. Your Rights</h3>
            <p data-id="element-503">
              Under applicable data protection laws, you have specific rights
              regarding your personal data. You have the right to:
            </p>
            <ul data-id="element-504">
              <li data-id="element-505">Request access to the personal data we hold about you.</li>
              <li data-id="element-506">Ask for corrections or deletion of your data.</li>
              <li data-id="element-507">
                Withdraw your consent to marketing communications at any time.
              </li>
            </ul>
            <p data-id="element-508">To exercise these rights, please contact us at:</p>
            <ul data-id="element-509">
              <li data-id="element-510">📧 manishkisan879@gmail.com</li>
              <li data-id="element-511">📞 0800 055 4969</li>
            </ul>
            <h3 data-id="element-512">7. Sharing Your Data</h3>
            <p data-id="element-513">We may share your information with:</p>
            <ul data-id="element-514">
              <li data-id="element-515">
                Service providers essential to our operations: Such as payment
                processors, IT support, and website hosting services, who act on
                our behalf.
              </li>
              <li data-id="element-516">
                Law enforcement or regulatory authorities: When required by law
                or in response to a valid legal request.
              </li>
              <li data-id="element-517">
                Marketing partners: But only with your explicit consent, which
                you can withdraw at any time.
              </li>
            </ul>
            <h3 data-id="element-518">8. Data Retention</h3>
            <p data-id="element-519">We retain your personal data only as long as necessary to:</p>
            <ul data-id="element-520">
              <li data-id="element-521">Provide and manage our services to you effectively.</li>
              <li data-id="element-522">Comply with legal and regulatory requirements.</li>
              <li data-id="element-523">Resolve disputes or complaints.</li>
            </ul>
            <h3 data-id="element-524">9. Children's Privacy</h3>
            <p data-id="element-525">
              Our services are not intended for individuals under 16 years old.
              We do not knowingly collect personal data from minors. If we
              become aware that such data has been collected, we will take steps
              to delete it.
            </p>
            <h3 data-id="element-526">10. Data Security</h3>
            <p data-id="element-527">
              We implement strong security measures, including technical and
              organizational safeguards, to protect your information from
              unauthorized access, accidental loss, destruction, or alteration.
              While we strive for robust security, please understand that no
              system can guarantee 100% security during data transmission over
              the internet.
            </p>
            <h3 data-id="element-528">11. International Data Transfers</h3>
            <p data-id="element-529">
              Your data may be stored or processed outside the UK or European
              Economic Area by our service providers. Where this happens, we
              ensure appropriate safeguards are in place to protect your data in
              accordance with relevant data protection laws.
            </p>
            <h3 data-id="element-530">12. Updates to This Policy</h3>
            <p data-id="element-531">
              We may update this privacy policy occasionally to reflect changes
              in our practices, technology, or legal requirements. Any changes
              will be published here with the updated date. We encourage you to
              review this policy regularly to stay informed.
            </p>
            <h3 data-id="element-532">13. Contact Us</h3>
            <p data-id="element-533">
              If you have any questions or concerns about your data or this
              policy, please do not hesitate to contact us:
            </p>
            <ul data-id="element-534">
              <li data-id="element-535">📧 manishkisan879@gmail.com</li>
              <li data-id="element-536">📞 0800 055 4969</li>
            </ul>
          </div>
        </div>
      </div>
    </div>;
};